import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Button,Form, FormGroup, Input, InputGroup,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { classNames } from 'primereact/utils';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { ProgressBar } from 'primereact/progressbar';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import { Slider } from 'primereact/slider';
import { Tag } from 'primereact/tag';
import { TriStateCheckbox } from 'primereact/tristatecheckbox';
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

const PrimeDataTable = () => {

  const history = useHistory();
  const [dataList, setDataList] = useState(null);
  const [filters, setFilters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [statuses] = useState([
    { label: 'Unqualified', value: 'unqualified' },
    { label: 'Qualified', value: 'qualified' },
    { label: 'New', value: 'new' },
    { label: 'Negotiation', value: 'negotiation' },
    { label: 'Renewal', value: 'renewal' },
    { label: 'Proposal', value: 'proposal' }
  ]);

  const getSeverity = (status) => {
    switch (status) {
      case 'unqualified':
        return 'danger';

      case 'qualified':
        return 'success';
      case 'Post':
        return 'success';
      case 'Pending':
        return 'danger';
      case 'new':
        return 'info';

      case 'negotiation':
        return 'warning';

      case 'renewal':
        return null;
    }
  };

  useEffect(() => {
    setDataList([
      { SQNo: 'SQ-00001', Systemseqno: '00001', name: 'batman', Date: '03-Jan-2025', status: 'Post', statuso: 'qualified', Price: 71558500 },
      { SQNo: 'SQ-00002', Systemseqno: '00002', name: 'PT. NIPPON STEEL BATAM OFFSHORE SERVICE', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 25500.56 },
      { SQNo: 'SQ-00003', Systemseqno: '00003', name: 'Mitra Energi Batam', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 75581500 },
      { SQNo: 'SQ-00004', Systemseqno: '00004', name: 'Sealico Gas Energy Pte Ltd', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 997881500 },
      { SQNo: 'SQ-00005', Systemseqno: '00005', name: 'Mitra Energi Batam', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 85605450 },
      { SQNo: 'SQ-00006', Systemseqno: '00006', name: 'Sealico Gas Energy Pte Ltd', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 111505520 },
      { SQNo: 'SQ-00007', Systemseqno: '00007', name: 'Sealico Gas Energy Pte Ltd', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 12155500 },
      { SQNo: 'SQ-00008', Systemseqno: '00008', name: 'PT. NIPPON STEEL BATAM OFFSHORE SERVICE', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 15241500 },
      { SQNo: 'SQ-00009', Systemseqno: '00009', name: 'PT. NIPPON STEEL BATAM OFFSHORE SERVICE', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 158750550 },
      { SQNo: 'SQ-0000q0', Systemseqno: '000010', name: 'Sealico Gas Energy Pte Ltd', Date: '03-Jan-2025', status: 'Pending', statuso: 'proposal', Price: 1505550 }
    ]);
    setLoading(false);
    initFilters();

  }, []);

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      SQNo: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      Systemseqno: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      Date: {
        operator: FilterOperator.AND,
        constraints: [
          { value: null, matchMode: FilterMatchMode.DATE_IS }, // Filter for an exact date
        ]
      },
      Price: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },

    });
    setGlobalFilterValue('');
  };

  const renderHeader = () => {
    return (
      <div className="row align-items-center g-3 clear-spa">

          <div className="col-12 col-lg-3">
            <Button
              className="btn btn-danger btn-label"
              onClick={clearFilter}
            >
              <i className="mdi mdi-filter-off label-icon" />
              Clear
            </Button>
          </div>
          <div className="col-12 col-lg-3">
            <input
              className="form-control"
              type="text"
              value={globalFilterValue} onChange={onGlobalFilterChange}
              placeholder="Keyword Search"
            />
          </div>
       
      </div>
    );
  };



  const statusBodyTemplate = (rowData) => {
    return <Tag value={rowData.status} severity={getSeverity(rowData.status)} />;
  };

  const statusFilterTemplate = (options) => {
    return <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={statusItemTemplate} placeholder="Select One" className="p-column-filter" showClear />;
  };

  const statusItemTemplate = (option) => {
    return <Tag value={option} severity={getSeverity(option)} />;
  };


  const actionBodyTemplate = (rowData) => {
    return (
      <div className="actions"> 
        <span style={{ marginRight: '0.5rem' }} title="Edit" onClick={() => editRow(rowData)} > 
          <i className="mdi mdi-square-edit-outline" style={{ fontSize: '1.5rem' }}></i>
        </span> 
      </div>
    )
  };


  const dateFilterTemplate = (options) => {
    return (
      <Calendar
        value={options.value}
        onChange={(e) => options.filterCallback(e.value, options.index)}
        dateFormat="dd-MMM-yyyy"
        placeholder="Filter by Date"
        showIcon
      />
    );
  };

  const header = renderHeader();

  const editRow = (rowData) => {
    console.log('Edit row:', rowData);

  };

  const deleteRow = (rowData) => {
    console.log('Delete row:', rowData);

  };

  const handleAddOrder = () => {
    history.push("/OrderEntry");
  };

  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Sales" breadcrumbItem="Sales Orders" />
          
          <Row>
          <Card className="search-top">
              <div className="row align-items-center g-3 "> 
                <div className="col-12 col-lg-2">
                  <div className="d-flex align-items-center gap-2">
                    <label htmlFor="sqNo" className="form-label mb-0">SO No.</label>
                    <input
                      id="soNo"
                      type="text"
                      className="form-control"
                      style={{ width: '72%' }}
                    />
                  </div>
                </div>

                {/* From Date */}
                <div className="col-12 col-lg-2">
                  <div className="d-flex align-items-center gap-2">
                    <label htmlFor="fromDate" className="form-label mb-0">From</label>
                    <FormGroup>
                          <Label></Label>
                          <InputGroup>
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="dd-mm-yyyy"
                              options={{
                                altInput: true,
                                altFormat: "d-M-Y",
                                dateFormat: "Y-m-d"
                              }}
                            />
                          </InputGroup>
                        </FormGroup>
                  </div>
                </div>

                {/* To Date */}
                <div className="col-12 col-lg-2">
                  <div className="d-flex align-items-center gap-2">
                    <label htmlFor="toDate" className="form-label mb-0">To</label>
                    <FormGroup>
                          <Label></Label>
                          <InputGroup>
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="dd-mm-yyyy"
                              options={{
                                altInput: true,
                                altFormat: "d-M-Y",
                                dateFormat: "Y-m-d"
                              }}
                            />
                          </InputGroup>
                        </FormGroup>
                  </div>
                </div>
                <div className="col-12 col-lg-4 button-items">
                  <button type="button" className="btn btn-info"> <i className="bx bx-search-alt label-icon font-size-16 align-middle me-2"></i> Search</button>                
                  <button type="button" className="btn btn-danger"><i className="bx bx-window-close label-icon font-size-14 align-middle me-2"></i>Cancel</button>                
                  <button type="button" className="btn btn-success" onClick={handleAddOrder}><i className="bx bx-plus label-icon font-size-16 align-middle me-2"></i>New</button>
                </div>
              </div>
            </Card> 
            <Col lg="12">
              <Card > 
                <DataTable value={dataList} paginator showGridlines rows={10} loading={loading} dataKey="id"
                  filters={filters} globalFilterFields={['name', 'SQNo', 'Systemseqno', 'status']} header={header}
                  emptyMessage="No order found." onFilter={(e) => setFilters(e.filters)} className='blue-bg' >
                  <Column field="SQNo" header="SO No." filter filterPlaceholder="Search by SO No"  className="text-center"/>
                  <Column field="Systemseqno" header="System Seq. No." filter filterPlaceholder="Search by System Seq. No." style={{width:'155px'}} className="text-center"/>
                  <Column field="Date" header="Date" filter filterPlaceholder="Search by date" filterElement={dateFilterTemplate} className="text-center"/>
                  <Column field="name" header="Customer Name" filter filterPlaceholder="Search by name" className="text-left"/>
                  <Column field="status" header="Status" filterMenuStyle={{ width: '14rem' }} body={statusBodyTemplate}  className="text-center"/>
                  <Column field="Price" header="Price (IDR)" filter className="text-end"/>
                  <Column field="Systemseqno" header="Action" showFilterMatchModes={false} body={actionBodyTemplate} className="text-center"/> 
                </DataTable> 
              </Card>
            </Col>
          </Row> 
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PrimeDataTable
